.intro {
  margin: .9em 3em;
  opacity: 0.5;
  font-size: .9em;
}
.shortcut_list {
  padding: 0 2em;

  --column-gap: .7em;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20em, 1fr));
  column-gap: var(--column-gap);
  .item {
    display: flex;
    box-sizing: border-box;
    flex-wrap: nowrap;
    overflow: hidden;
    .button {
      &.activated {
        background-color: hsl(0, 0%, 70%);
      }
      &.has_duplicate {
        background-color: hsl(0, 70%, 70%);
      }
      display: flex;
      flex-wrap: nowrap;
      overflow: hidden;
      height: 1.5lh;

      .keys {
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: fit-content 0 0;
        max-width: 50%;
        display: inline-block;
        .key {
          display: inline-block;
          margin-left: .7em;
          &:not(:last-child)::after {
            content: ", ";
          }
        }
      }
      .title {
        margin-left: .7em;
        display: inline-block;
        flex-grow: 2;
        flex-shrink: 2;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
      }
    }
  }
}

.title {
  &:not(input):empty, &:is(input:placeholder-shown) {
    color: hsl(195, 20%, 50%, .5);
    &::after{
      content: "<empty>"
    }
  }
}
.current_preset_select {
  margin: 1.5em;
  .active_preset {
    font-weight: bold;
  }
  button {
    margin-left: 2.5em;
  }
}

.edit_dialog {
  max-width: 50vw;
  h2 {
    display: flex;
    align-items: center;
    font-size: 1.5em;
    column-gap: 1.3em;
    .icon {
      font-size: 2em;
      flex: 0 0 fit-content;
    }
    .title {
      flex: 1;
      &.invalid_title {
        background-color: hsl(0, 70%, 70%);
      }
    }
  }
  h3 {}
  .duplicate_keys_explain {
    color: hsl(0, 70%, 20%);
  }
  .shortcuts {
    padding: 1.5em;
    width: 100%;
    box-sizing: border-box;
    .add_button_small {
      border: none;
      background-color: unset;
      &:hover {
        background-color: hsl(0, 0%, 0%, .2);
      }
    }
    .key_list {
      display: flex;
      flex-flow: column nowrap;
      align-items: stretch;
      width: 100%;
      .shortcut_row {
        display: flex;
        flex-flow: row nowrap;
        &:hover {
          background-color: hsl(0, 0%, 0%, .1);
        }
        button {
          flex: 0 0 2em;
          border: none;
          background-color: unset;
          &:hover:not(:disabled) {
            background-color: hsl(0, 0%, 0%, .2);
          }
        }
        .shortcut_key  {
          height: 1.3lh;
          box-sizing: border-box;
          flex-grow: 1;
        }
        &.shortcut_is_duplicate {
          background-color: hsl(0, 70%, 70%);
        }
        &.editing_key .shortcut_key {
          background-color: hsl(0, 0%, 100%, .8);
          border: 2px solid hsl(240, 100%, 40%, .8);
          &:empty{
            color: silver;
            &::after {
              content: "<recording keystroke> (press key now)";
            }
          }
        }
      }
    }
  }
}
.error_popup {
  max-width: 50vw;
  div {
    margin: 1.5em 0;
  }
}
.preset_editor {
  max-width: 50vw;
  ul {
    padding: 0;
    li {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      gap: .4em;
      .preset_selected {
        flex: 0;
      }
      .preset_name {
        flex: 1;
        input {
          width: 100%;
        }
        cursor: default;
        &.name_edit_error input {
          cursor: auto;
          background-color: hsl(0, 70%, 70%);
        }
      }
      & > button{
        &.save_button {
          display: none;
        }
        &:hover {
          background-color: hsl(0, 0%, 0%, .2);
        }
      }
    }
    &.editing {
      li > button {
        display: none;
        &.save_button {
          display: block;
          opacity: 1;
        }
      }
    }
    &:not(.editing) {
      li:hover {
        background-color: hsl(0, 0%, 0%, .1);
      }
    }
  }
}

.quick_shortcut_list {
  dl{
    &:empty::before {
      opacity: .4;
      content: "<No actions are defined for this preset>"
    }
    dt {
      display: inline;
      &::after {
        content: ": "
      }
    }
    dd {
      margin: 0;
      display: inline;
      &::after {
        content: "";
        display: block;
      }
      &:empty::before {
        opacity: .4;
        content: "<no shortcuts keys defined>"
      }
      & > div {
        display: inline-block;
        & + div {
          &::before {
            content: ", ";
          }
        }
      }
    }
}
}
.confirm_box {
  max-width: 40vw;
}
